import { Route } from "react-router-dom"
import React from "react"
import ServiceRequestLayout from "./ServiceRequestLayout"
import ReviewRequest from "./ReviewRequest/ReviewRequest"
import AddVehicle from "./AddVehicle/AddVehicle"
import ShopSelection from "./SelectShop/ShopSelection"
import Appointment from "./Appointment"
import { routerPaths } from "../../../v1/constants/paths"
import AddPaymentDetails from "./AddPaymentDetails"
import CompareVehicle from "./CompareVehicle"
import UpdateUser from "./UpdateUser"
import SearchServices from "./SelectService/SearchServices"
import SelectService from "./SelectService/SelectService"
import ReviewAppointment from "./ReviewAppointment "
import ReviewServices from "./SelectService/ReviewServices"
import SelectVehicle from "./AddVehicle/SelectVehicle"
import VehicleInfo from "./AddVehicle/VehicleInfo"
import RecommendedServices from "./RecommendedServices"
export const ServiceRequest = (props) => {
  return (
    <Route
      path="/service-request"
      render={() => (
        <ServiceRequestLayout>
          <Route path={routerPaths.compareVehicle} component={CompareVehicle} />
          <Route path={routerPaths.updateUser} component={UpdateUser} />
          <Route path={routerPaths.addVehicle} component={AddVehicle} />
          <Route path={routerPaths.reviewAppointment} component={ReviewAppointment} />
          <Route path={routerPaths.searchService} component={SearchServices} />
          <Route path={routerPaths.selectService} component={SelectService} />
          <Route path={routerPaths.shopSelection} component={ShopSelection} />
          <Route path={routerPaths.appointment} component={Appointment} />
          <Route path={routerPaths.reviewRequest} component={ReviewRequest} />
          <Route path={routerPaths.addPayment} component={AddPaymentDetails} />
          <Route path={routerPaths.reviewServices} component={ReviewServices} />
          <Route path={routerPaths.selectVehicle} component={SelectVehicle} />
          <Route path={routerPaths.confirmVehicle} component={VehicleInfo} />
          <Route path={routerPaths.recommendedServices} component={RecommendedServices} />
        </ServiceRequestLayout>
      )}
    />
  )
}
